import { PASSAGES_SUCCESS } from '../../actions/passages';

const defaultState = {
  passages: [],
};

export default function reducer(state = defaultState, action) {
  if (action.type === PASSAGES_SUCCESS) {
    return { ...action.payload };
  }

  return state;
}
